define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'internal_util/ClientUtil',
	'model/EidClient',
	'model/AuthenticationOption',
	'model/AuthenticationOptionGroup',
	'amdi18n-loader?!model/eidclient/nls/TR03124_EP_Client_strings'
], function (
	Logger,
	Util,
	Configuration,
	ClientUtil,
	EidClient,
	AuthenticationOption,
	AuthenticationOptionGroup,
	Strings
) {
	'use strict';

	function TR03124_EP_Client() {
		var _id = 'http://ws.skidentity.de/oi/go/client/TR03124_EP_Client',
			_name = 'TR03124_EP_Client',
			_baseAddress = 'eid://127.0.0.1:24727/eID-Client?',
			_supportedCardsProtocols = {
					'http://bsi.bund.de/cif/npa.xml' : [
						'urn:oid:1.3.162.15480.3.0.9',
						'urn:oid:1.3.162.15480.3.0.14',
						'urn:oid:1.3.162.15480.3.0.25'
					]
				},
			_enabled = false;

		EidClient.call(this, _id);


		// private methods

		function log(method, message, data) {
			Logger.log(_name, method, message, data);
		}


		// public methods


		this.enableDetection = function () {
			_enabled = true;
		};

		this.disableDetection = function () {
			_enabled = false;
		};

		this.name = function () {
			return _name;
		};

		this.supportsPlatform = function () {
			return ClientUtil.isMobileClient();
		};

		this.supportsAuthenticationOption = function (authenticationOption) {
			if (authenticationOption instanceof AuthenticationOption) {
				return _supportedCardsProtocols.hasOwnProperty(authenticationOption.type());
			} else if (authenticationOption instanceof AuthenticationOptionGroup
					&& authenticationOption.authenticationOptions().length === 1) {
				return _supportedCardsProtocols.hasOwnProperty(
							authenticationOption.authenticationOptions()[0].type());
			}

			return false;
		};

		this.supportsStatus = function () {
			return false;
		};

		this.detect = function (callbacks, errorCallbacks) {
			var _name = 'detect';

			log(_name, Strings.detection_started);

			if (_enabled) {
				log(_name, Strings.detection_successful, _enabled);
				Util.callCallbacks(callbacks);
			} else {
				log(_name, Strings.detection_failed, _enabled);
				Util.callCallbacks(errorCallbacks);
			}
		};

		this.start = function () {
			// Nothing to do here
		};

		this.stop = function () {
			// Nothing to do here
		};

		this.activate = function (authenticationOption, tcTokenURL, callbacks) {
			var eidClientUrl = _baseAddress + 'tcTokenURL=';

			eidClientUrl += encodeURIComponent(tcTokenURL);

			Util.callCallbacks(callbacks);
			ClientUtil.redirectTo(eidClientUrl);
		};

		this.toObject = function () {
			return _name;
		};
	}

	TR03124_EP_Client.prototype = Object.create(EidClient.prototype);

	return TR03124_EP_Client;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/eidclient/TR03124_EP_Client.js
// module id = 281
// module chunks = 3